export const PageStates = {
    neutral: 'neutral',
    loading: 'loading',
    submitting: 'submitting',
    submitted: 'submitted',
};
